(function(window, document) {
    'use strict'

    const internal = window.RTAnalyticsInternal

    function getDedupeKey(eventName, bannerId) {
        return [
            internal.eventFactory.getPageId(),
            eventName,
            bannerId || 'unknown'
        ].join(':')
    }

    function handleView(event) {
        const detail = event.detail || {}
        window.RT.analytics.track(
            'popupBanner.view',
            {bannerId: detail.bannerId || null},
            {
                source: 'popup-banner',
                dedupeKey: getDedupeKey('view', detail.bannerId)
            }
        )
    }

    function handleClick(event) {
        const detail = event.detail || {}
        const ticket = window.RT.analytics.track(
            'popupBanner.click',
            {bannerId: detail.bannerId || null},
            {
                source: 'popup-banner',
                dedupeKey: getDedupeKey('click', detail.bannerId)
            }
        )

        if (typeof detail.waitUntil === 'function') {
            detail.waitUntil(ticket.persisted)
        }
    }

    document.addEventListener('rt:popup-banner:shown', handleView)
    document.addEventListener('rt:popup-banner:link-followed', handleClick)
})(window, document)
